'use client'
import Container from '@/components/layout/container';
import { Box } from '@/components/layout/box';
import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import styles from './line-chart.module.scss';
import {
  Chart as ChartJS,
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale,
} from 'chart.js';

// Register the components
ChartJS.register(
  LineElement,
  PointElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  CategoryScale
);

interface LineChartProps {
  data: Array<{ time_created: string; amount: number }>;
}

export default function LineChart({ data }: LineChartProps) {

  // Ensure data is an array
  if (!Array.isArray(data)) {
    console.error('Data is not an array:', data);
    return null;
  }

  // Reverse the data array to show most recent prices last
  const reversedData = [...data].reverse();

  // Extract labels and dataset from the reversed data
  const labels = data.map((result) => {
    const date = new Date(result.time_created);
    const formattedDate = `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;
    return formattedDate;
  });
  const filteredData = reversedData;
  const dataset = filteredData.map((result) => result.amount);
  

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'price',
        backgroundColor: 'rgba(75,192,192,0.4)',
        borderColor: 'rgba(75,192,192,1)',
        borderWidth: 1.25,
        hoverBackgroundColor: 'rgba(75,192,192,0.4)',
        hoverBorderColor: 'rgba(75,192,192,1)',
        data: filteredData.map((item) => item.amount / 100),
        pointRadius: 0, // Exclude the point/dots
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        type: 'category',
        // labels: filteredData.map((item) => new Date(item.time_created).toLocaleDateString('en-US')),
        display: false,
      },
      y: {
        beginAtZero: true,
        ticks: {
          callback: function(value) {
            return '$' + value.toFixed(2);
          }
        },
      },
    },
  };

  return (
    <Container>
      <Box className={styles.chartWrapper}>
        <Line className={styles.chart} data={chartData} options={options} />
      </Box>
    </Container>
  );
}


